import store from '@/store/index';
import { getCookie } from '@lhb/cache';
export var getBigDataExtra = function () {
    var _a;
    var common = store.state.common;
    return {
        companyId: common.companyId,
        store_id: getCookie('placeIds') ? (_a = getCookie('placeIds')) === null || _a === void 0 ? void 0 : _a.split(',') : 0,
        user_tel: common.user ? common.user.mobile : '',
    };
};
